import { render, staticRenderFns } from "./RSVPForm.vue?vue&type=template&id=1b40356c&scoped=true&"
import script from "./RSVPForm.vue?vue&type=script&lang=js&"
export * from "./RSVPForm.vue?vue&type=script&lang=js&"
import style0 from "./RSVPForm.vue?vue&type=style&index=0&id=1b40356c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40356c",
  null
  
)

export default component.exports